import { IsEmail, IsNotEmpty, IsString } from 'class-validator'
import { ApiProperty } from '@nestjs/swagger'

export class LoginRequest {
	@ApiProperty({ type: String, format: 'email' })
	@IsNotEmpty()
	@IsString()
	@IsEmail()
	email: string

	@ApiProperty({ type: String, format: 'password' })
	@IsNotEmpty()
	@IsString()
	password: string
}

export class LoginResponse {
	@ApiProperty({ type: String })
	access_token: string
}
